import { useUser } from "@auth0/nextjs-auth0/client";
import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { getUserAccounts } from "./utils/get-user-accounts";
import { getUserObject } from "./utils/get-user-object";
import { getUserRoles } from "./utils/get-user-roles";
export const useAuth = (customer) => {
    let initialState = {
        isLoading: true,
        user: undefined,
        roles: [],
    };
    const [auth, setAuth] = useState(initialState);
    const { user, isLoading } = useUser();
    const cookies = new Cookies();
    useEffect(() => {
        var _a, _b;
        if (user) {
            const userProfile = getUserObject(user);
            let userRoles = getUserRoles(user);
            const accounts = getUserAccounts(user);
            const customerId = cookies.get("customer");
            if (customerId &&
                accounts.find((account) => account.customerId === customerId) &&
                accounts.length > 1 // Account for CustomerID with Multiple Accounts
            ) {
                userRoles = getUserRoles(user, customerId);
            }
            else if (accounts.length > 1) {
                cookies.set("customer", (_a = accounts[0]) === null || _a === void 0 ? void 0 : _a.customerId, {
                    path: "/",
                    expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365),
                });
            }
            else {
                cookies.set("customer", (_b = accounts[0]) === null || _b === void 0 ? void 0 : _b.customerId, {
                    path: "/",
                    expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365),
                });
            }
            setAuth((prev) => (Object.assign(Object.assign({}, prev), { user: userProfile, roles: userRoles, isLoading })));
        }
        else {
            setAuth((prev) => (Object.assign(Object.assign({}, prev), { isLoading })));
        }
    }, [user, isLoading, customer]);
    return auth;
};
/**
 * Redirect to login page.
 *
 * @param basePath - Optional base path for the app
 */
export const login = (basePath) => {
    var _a;
    // Extract connection parameter from current page URL to pass to login
    const urlParams = new URLSearchParams(window.location.search);
    const urlPath = window.location.pathname;
    const connection = (_a = urlParams.get("connection")) !== null && _a !== void 0 ? _a : urlParams.get("conn");
    // Build login URL
    const basePathValue = basePath !== null && basePath !== void 0 ? basePath : "";
    const loginUrl = new URL(`${window.location.origin}${basePathValue}/api/auth/login`);
    // Include connection parameter if present and non-empty
    if (typeof connection === "string" && connection.trim().length > 0) {
        loginUrl.searchParams.set("connection", connection.trim());
    }
    // Set returnTo to current path (but not if we're already on an auth route)
    if (urlPath.length > 0 &&
        !urlPath.startsWith("/auth/") &&
        !urlPath.startsWith("/api/auth/")) {
        loginUrl.searchParams.set("returnTo", urlPath.trim());
    }
    window.location.replace(loginUrl.toString());
};
/**
 * Redirect to logout page.
 *
 * @param basePath - Optional base path for the app
 */
export const logout = (basePath) => {
    window.location.replace(`${window.location.origin}${basePath !== null && basePath !== void 0 ? basePath : ""}/api/auth/logout`);
};
